import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import { cn } from "~/utils";
import { CourseTypeLonzenge } from "~/components/general/CoursesDropdown";

export const CourseAvatar = ({ authorName, authorPic = null }) => (
  <>
    {authorPic ? (
      <img src={authorPic} className="h-10 w-10" />
    ) : (
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-300 font-semibold">
        {authorName
          .split(" ")
          .map((s) => s[0].toUpperCase())
          .join("")}
      </div>
    )}
  </>
);

export const CourseAddedLabel = ({ className }) => (
  <div
    className={cn("flex items-center gap-0.5 text-xs text-teal-600", className)}
  >
    <span className="font-semibold">Added</span>
    <CheckIcon color="inherit" fontSize="inherit" />
  </div>
);

const CourseCard = ({
  className,
  course = {},
  courseAlreadyAdded,
  onClick,
  showClasses = false,
}) => {
  const {
    authorName,
    classes = [],
    coid,
    name: courseName,
    numberOfModules,
    thumb: authorPic,
    type: courseType,
  } = course;
  return (
    <div
      className={cn(
        "flex cursor-pointer select-none flex-col justify-between gap-4 rounded-md border bg-white p-2.5 shadow transition",
        courseAlreadyAdded
          ? "border-teal-400 hover:border-teal-500"
          : "border-gray-300 hover:border-gray-400",
        className,
      )}
      onClick={onClick}
    >
      <div className="flex items-start justify-between gap-4">
        <CourseAvatar authorName={authorName} authorPic={authorPic} />
        <CourseTypeLonzenge className="text-xs font-bold" type={courseType} />
      </div>
      <div className="flex items-end justify-between gap-4">
        <div className="flex flex-col">
          <span className="text-sm text-gray-500">{authorName}</span>
          <span className="font-bold">{courseName}</span>
          {typeof numberOfModules === "number" && (
            <span className="pt-1 text-sm text-gray-700">{`${numberOfModules} module${numberOfModules === 1 ? "" : "s"}`}</span>
          )}
          {showClasses && (
            <div
              className={cn(
                "flex flex-wrap items-center gap-2",
                classes.length ? "mt-2" : "mt-1",
              )}
            >
              {classes.length === 0 && (
                <span className="text-xs text-gray-400">
                  No classes
                </span>
              )}
              {classes.map(({ cid, name }) => (
                <span
                  className="rounded-md bg-gray-200 px-2 py-0.5 text-xs text-gray-600"
                  key={`course-${coid}-class-${cid}`}
                >
                  {name}
                </span>
              ))}
            </div>
          )}
        </div>
        {courseAlreadyAdded && <CourseAddedLabel />}
      </div>
    </div>
  );
};

export default CourseCard;
